import axiosInstance from './axiosInstance';
import { toast } from 'react-toastify';

// GET request function
export const getRequest = async (url) => {
  try {
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    console.error('Error in GET request:', error);
    throw error;
  }
};

// POST request function
export const postRequest = async (url, data) => {
  try {
    const response = await axiosInstance.post(url, data);
    
    return response.data;
  } catch (error) {
    toast.error(error.response.data.errors[0].detail, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeButton: true,
    });
    console.error('Error in POST request:', error);
    throw error;
  }
};

// PUT request function
export const putRequest = async (url, data) => {
  try {
    const response = await axiosInstance.put(url, data);
    return response.data;
  } catch (error) {
    console.error('Error in PUT request:', error);
    throw error;
  }
};

// PATCH request function
export const patchRequest = async (url, data) => {
  try {
    const response = await axiosInstance.patch(url, data);
    return response.data;
  } catch (error) {
    console.error('Error in PATCH request:', error);
    throw error;
  }
};
export const deleteRequest = async (url) => {
  try {
    const response = await axiosInstance.delete(url);
    return response.data;
  } catch (error) {
    // Enhanced error handling for DELETE requests
    let errorMessage = "Failed to delete resource";

    if (error.response) {
      if (error.response.data) {
        if (
          error.response.data.errors &&
          Array.isArray(error.response.data.errors)
        ) {
          errorMessage =
            error.response.data.errors[0].detail ||
            error.response.data.errors[0].message ||
            errorMessage;
        } else if (error.response.data.message) {
          errorMessage = error.response.data.message;
        } else if (error.response.data.error) {
          errorMessage = error.response.data.error;
        } else if (typeof error.response.data === "string") {
          errorMessage = error.response.data;
        }
      } else {
        switch (error.response.status) {
          case 400:
            errorMessage = "Invalid request for deletion.";
            break;
          case 401:
            errorMessage = "Unauthorized. Please login again.";
            break;
          case 403:
            errorMessage =
              "Forbidden. You don't have permission to delete this resource.";
            break;
          case 404:
            errorMessage = "Resource not found for deletion.";
            break;
          case 409:
            errorMessage =
              "Conflict. Resource cannot be deleted due to dependencies.";
            break;
          case 422:
            errorMessage = "Validation error. Resource cannot be deleted.";
            break;
          case 500:
            errorMessage = "Internal server error. Please try again later.";
            break;
          default:
            errorMessage = `Deletion failed with status ${error.response.status}`;
        }
      }
    } else if (error.request) {
      errorMessage = "Network error. Please check your connection.";
    } else {
      errorMessage =
        error.message || "An unexpected error occurred during deletion";
    }

    toast.error(errorMessage, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeButton: true,
    });

    console.error("Error in DELETE request:", error);
    throw error;
  }
};
